import { Sidebar } from "@trafficsharkdsp/ui";
import cl from "classnames";
import { useCallback, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useGetSidebarItems } from "../lib/useGetSidebarItems";

import cls from "./Sidebar.module.css";

import { SIDEBAR_TUTORIAL_ANCHORS, tutorialAnchor } from "@/features/tutorial";
import { removeTrailingSlash } from "@/shared/lib/removeSlashFromURL";

export const SidebarLock = () => {
    const [open, setOpen] = useState(true);
    const items = useGetSidebarItems(open);
    const { pathname } = useLocation();
    const activeItem = removeTrailingSlash(pathname);

    const handleToggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);

    return (
        <Sidebar
            isOpen={open}
            activeItem={activeItem}
            onToggle={handleToggle}
            itemRender={(node, item) => {
                return item.key && item.key !== "0" ? (
                    <Link
                        key={item.key}
                        className={cl(cls.item, !open && cls["item-close"])}
                        to={item.key}
                        data-qa={item.qaTag}
                        {...tutorialAnchor(SIDEBAR_TUTORIAL_ANCHORS[item.key])}
                    >
                        {node}
                    </Link>
                ) : (
                    node
                );
            }}
            itemClassName={cls.item}
            className={cl(cls.sidebar, { [cls.open]: open })}
            items={items}
        />
    );
};
